import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full  py-4 bg-gray-800 text-center">
      <h1 className="text-white">All Rights Reserved Kaizen Global 2024</h1>
      <Link to={"/terms-and-services"} className="text-[white] underline mt-2">
        Terms and Services
      </Link>
      <Link
        style={{ marginLeft: 12 }}
        to={"/privacy-policy"}
        className="text-[white] underline mt-2"
      >
        Privacy Policy
      </Link>
      <Link
        style={{ marginLeft: 12 }}
        to={"/delete-data"}
        className="text-[white] underline mt-2"
      >
        Delete data and revoke access
      </Link>
    </footer>
  );
}
